<template>
    <div>
        <el-card class="allot_card">
            <div slot="header" class="clearfix">
                <span style="line-height: 36px;">出货记录</span>
                <el-button style="float: right;margin-left:10px;" type="success" @click="search()">查询</el-button>
                <el-date-picker
                    style="float: right;"
                    v-model="date_value"
                    type="daterange"
                    align="right"
                    :placeholder="today"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    :picker-options="pickerOptions">
                </el-date-picker>
            </div>
            <div>
                <el-table
                v-loading="table_loading"
                element-loading-text="拼命加载中"
                :data="deviceData"
                height="520"
                stripe
                border
                fit
                style="width: 100%">
                <el-table-column
                    prop="id"
                    header-align="center"
                    min-width="95"
                    label="ID">
                </el-table-column>
                <el-table-column
                    prop="nickName"
                    header-align="center"
                    min-width="120"
                    label="昵称">
                </el-table-column>
                <el-table-column
                    prop="sex"
                    header-align="center"
                    min-width="85"
                    label="性别">
                </el-table-column>
                <el-table-column
                    prop=""
                    header-align="center"
                    min-width="295"
                    label="头像">
                    <template scope="scope">
                      <div >
                        <img :src="scope.row.link" alt="" style="width:60px;vertical-align:middle;margin:5px;">
                      </div>
                    </template>
                </el-table-column>
                <el-table-column
                    prop="oid"
                    header-align="center"
                    min-width="165"
                    label="订单编号">
                </el-table-column>
                <el-table-column
                    prop="money"
                    header-align="center"
                    min-width="85"
                    label="金额">
                </el-table-column>
                <el-table-column
                    prop="createTime"
                    header-align="center"
                    min-width="205"
                    label="下单时间">
                </el-table-column>
                <el-table-column
                    prop="payType"
                    header-align="center"
                    min-width="85"
                    label="支付方式">
                    <template scope="scope">
                        <span>{{scope.row.payType===0 ? '微信':(scope.row.payType===1)?'支付宝':'免费' }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    prop=""
                    header-align="center"
                    min-width="85"
                    label="操作">
                    <template scope="scope">
                        <el-button v-if='scope.row.refund!=1' type="text" size="small" @click="refund(scope.row.oid)" :disabled="scope.row.payType===null">退款</el-button>
                        <el-button v-if='scope.row.refund==1' type="text" size="small" disabled>已退款</el-button>
                    </template>
                </el-table-column>
                </el-table>
            </div>
            <div class="table_pagination">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pageNo"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="pageTotal">
                </el-pagination>
            </div>
        </el-card>
    </div>
</template>
<script>
    import $axios from '../../https/config'

    export default {
      props: ['deviceCode', 'theUuid'],
      data () {
        return {
          pickerOptions: {
            shortcuts: [{
              text: '最近一周',
              onClick (picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
                picker.$emit('pick', [start, end])
              }
            }, {
              text: '最近一个月',
              onClick (picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
                picker.$emit('pick', [start, end])
              }
            }, {
              text: '最近三个月',
              onClick (picker) {
                const end = new Date()
                const start = new Date()
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
                picker.$emit('pick', [start, end])
              }
            }]
          },
          deviceData: [],
          pageTotal: 0,
          pageSize: 10,
          pageNo: 1,
          table_loading: false,
          date_value: '',
          today: new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate() + ' - ' + new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate(),
          startDate: new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate(),
          endDate: new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate()
        }
      },
      created: function () {
        this.pageNo = 1
        this.queryDeviceList(this.pageNo, this.pageSize, '')
      },
      methods: {
        boxClose (tType) {
          this.$emit('boxClose', tType)
        },
        queryDeviceList (tPageNo, tPageSize, tttt) {
          this.deviceData = []
          var _this = this
          var params = {
            pageNo: tPageNo,
            pageSize: tPageSize,
            uuid: _this.theUuid,
            startDate: _this.startDate,
            endDate: _this.endDate
          }
          _this.table_loading = true
          $axios.get('/device/queryDeviceOutPaper', params, 'headers', function (res) {
            if (res && res.resultStatus === true) {
              var resData = []
              if (res.resultData && res.resultData.list.length > 0) {
                _this.pageTotal = res.resultData.count
                for (var i = 0; i < res.resultData.list.length; i++) {
                  var itemData = res.resultData.list[i]
                  var item = []
                  var isRefund = 0 // 未退款
                  if (itemData.giveRecordPay !== null) {
                    isRefund = itemData.giveRecordPay.status === 2 ? 1 : 0 // status等于2为已退款
                  } else if (itemData.aliPayRecord !== null) {
                    isRefund = itemData.aliPayRecord.refund === 1 ? 1 : 0
                  }
                  if(itemData.giveRecord !== null){
                  if (itemData.giveRecord.payType !== null) {
                    var myGiveRecordPay = itemData.giveRecordPay
                    var myAliPayRecord = itemData.aliPayRecord
                    var myPayType = ''
                    if(itemData.giveRecord.payType !== 1){
                      if(myGiveRecordPay !== null){
                        myPayType = (itemData.giveRecordPay.charge / 100).toFixed(2)
                      }
                    }else{
                      if(myAliPayRecord !== null){
                        myPayType =(itemData.aliPayRecord.totalPrice / 100).toFixed(2)
                      }
                    }

                    item = {
                      id: itemData.giveRecord.id,
                      createTime: itemData.giveRecord.createTime,
                      status: itemData.giveRecord.status,
                      refund: isRefund,
                      nickName: itemData.userAccount === null ? '--' : itemData.userAccount.nickname,
                      link: itemData.userAccount === null ? '--' : itemData.userAccount.head_img_url,
                      money: myPayType,
                      aliPayRecord: itemData.aliPayRecord,
                      giveRecordPay: itemData.giveRecordPay,
                      payType: itemData.giveRecord.payType,
                      oid: itemData.giveRecord.oid,
                      sex: itemData.userAccount === null ? '--' : itemData.userAccount.sex === 1 ? '男' : (itemData.userAccount.sex === 2) ? '女' : '未知'
                    }
                  } else {
                    item = {
                      id: itemData.giveRecord.id,
                      createTime: itemData.giveRecord.createTime,
                      status: itemData.giveRecord.status,
                      refund: isRefund,
                      nickName: itemData.userAccount === null ? '--' : itemData.userAccount.nickname,
                      link: itemData.userAccount === null ? '--' : itemData.userAccount.head_img_url,
                      money: 0.00,
                      aliPayRecord: itemData.aliPayRecord,
                      giveRecordPay: itemData.giveRecordPay,
                      payType: itemData.giveRecord.payType,
                      oid: itemData.giveRecord.oid,
                      sex: itemData.userAccount === null ? '--' : itemData.userAccount.sex === 1 ? '男' : (itemData.userAccount.sex === 2) ? '女' : '未知'
                    }
                  }
                  resData.push(item)
                  }
                  
                }
                _this.deviceData = resData
              }
            } else {
            }
            _this.table_loading = false
          }, function () {})
        },
        refund (oid) {
          var _this = this
          _this.$confirm('确定进行退款？', '退款提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            var params = {
              // charge: giveRecordPay.charge,
              // createTime: giveRecordPay.createTime,
              // deviceCode: giveRecordPay.deviceCode,
              // id: giveRecordPay.id,
              oid: oid
              // openid: giveRecordPay.openid,
              // payType: giveRecordPay.payType,
              // status: giveRecordPay.status,
              // transactionId: giveRecordPay.transactionId,
              // userId: giveRecordPay.userId
            }
            $axios.post('/device/deviceOutPayRefound', params, 'headers', function (res) {
              if (res && res.resultStatus === true) {
                _this.queryDeviceList(_this.pageNo, _this.pageSize)
                _this.$message({
                  type: 'success',
                  message: '退款成功!'
                })
              } else {
                _this.$message({
                  type: 'error',
                  message: res.errorMessage
                })
              }
            }, function () {
              _this.$message({
                type: 'error',
                message: '退款失败'
              })
            })
          }).catch(() => {
          })
        },
        search () {
          this.pageNo = 1
          if (this.date_value !== '') {
            this.startDate = this.date_value[0].getFullYear() + '-' + (this.date_value[0].getMonth() + 1) + '-' + this.date_value[0].getDate()
            this.endDate = this.date_value[1].getFullYear() + '-' + (this.date_value[1].getMonth() + 1) + '-' + this.date_value[1].getDate()
          }
          this.queryDeviceList(this.pageNo, this.pageSize)
        },
        handleSizeChange (val) {
          this.pageSize = val
          this.queryDeviceList(this.pageNo, this.pageSize)
        },
        handleCurrentChange (val) {
          this.pageNo = val
          this.queryDeviceList(this.pageNo, this.pageSize)
        }
      }
    }
</script>
<style lang="scss">
    .allot_card {
        margin: 10px;
        position: relative;
        overflow-y: auto;
        height: 85%;

        .el-card__header {
            padding: 10px;
        }
        .el-card__body {
            padding: 10px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/page/deviceMgr/seeOutPaperRecord.vue